"use client"
import { motion, MotionProps } from 'framer-motion'
import React from 'react'

interface AnimatedSectionProps extends MotionProps {
  children: React.ReactNode
  className?: string
}

export default function AnimatedSection({
  children,
  className = '',
  initial = { opacity: 0, y: 40 },
  whileInView = { opacity: 1, y: 0 },
  viewport = { once: true, amount: 0.7 },
  transition = { duration: 0.8, ease: 'easeOut' },
  ...props
}: AnimatedSectionProps) {
  return (
    <motion.div
      className={className}
      initial={initial}
      whileInView={whileInView}
      viewport={viewport}
      transition={transition}
      {...props}
    >
      {children}
    </motion.div>
  )
} 